import { NgModule } from '@angular/core';
import { FoodsPage } from 'pages/foods/foods';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [FoodsPage],
    imports: [PagesModule, ComponentsModule],
    exports: [FoodsPage]
})
export class FoodsPageModule { }
